import React, { useState, useEffect } from 'react';
import logoImg from "../../assets/logo.png";
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { authAction } from "../../shared/Store/Slice/auth";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { uiActions } from '../../shared/Store/Slice/ui';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

export const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const dispatch = useDispatch();
    
    const toggleFilters = () => {
        dispatch(uiActions.toggleFilters());
    };

    const navigate = useNavigate();

    const handleScroll = () => {
        if (window.scrollY > 10) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    const { token } = useSelector((state) => state.auth);

    const logout = useDispatch();

    const logoutHandler = async () => {
        try {
            await logout(authAction.logout());
            localStorage.removeItem('token')
            localStorage.removeItem('userDetails')
            localStorage.clear()
            navigate("/");
            toast.success("Logout Successfully!")
        }
        catch (error) {
            toast.error('Something went wrong. Please try again later.')
        }
    }

    useEffect(() => {
        const debounceScroll = () => {
            window.addEventListener('scroll', handleScroll);
        };
        debounceScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const serializedState = localStorage.getItem('selectedProducts');
    const products = JSON.parse(serializedState) || [];

    const totalProducts = products.length > 0 ? products.length : 0;

    const handleNavClick = () => {
        setIsOpen(false); 
    };

    return (
        <div className={`main-header ${scrolled ? ' small' : ''}`}>
            <div className={`header ${scrolled ? 'small' : ''}`}>
                <div className="header-panel">
                    <div className={`logo-wraper ${scrolled ? 'hidden' : ''}`}>
                        <div className='logo'>
                            <NavLink className="nav-link" to="">
                                <img src={logoImg} alt="logo" loading="lazy" />
                            </NavLink>
                        </div>

                        <div className='icon-wrap'>
                            <div className="nav-item m-0 d-block d-lg-none me-2">
                                <button className="nav-link" onClick={toggleFilters} title='Filter'>
                                    <FilterAltIcon />
                                </button>
                            </div>

                            <button
                                className={`navbar-toggler ${isOpen ? 'open' : ''}`}
                                type="button"
                                onClick={toggleMenu}
                                aria-label="Toggle navigation"
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>

                        </div>
                    </div>
                    <div className='main-nav'>
                        <nav className="navbar navbar-expand-lg">
                            <div className="container-fluid p-0">
                                <div className={`collapse navbar-collapse w-100 ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
                                    <ul className="navbar-nav bg-white">
                                        <li className="nav-item">
                                            <NavLink className="nav-link" to="/shop" activeclassname="active" onClick={handleNavClick}>
                                                Shop
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink className="nav-link" activeclassname="active" to="/catalog" onClick={handleNavClick}>
                                                Current Catalog
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink activeclassname="active" className="nav-link" to="https://www.youtube.com/@houseofkurties/videos" target='_blank' onClick={handleNavClick}>
                                                How to Videos
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink activeclassname="active" className="nav-link" to="/about" onClick={handleNavClick} >
                                                About
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink activeclassname="active" className="nav-link" to="/contact" onClick={handleNavClick}   >
                                                Contact
                                            </NavLink>
                                        </li>
                                        {token ?
                                            <>
                                                <li className="nav-item">
                                                    <NavLink activeclassname="active" className="nav-link" to="/account" onClick={handleNavClick}>
                                                        My Account
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink onClick={logoutHandler} className="nav-link logout">
                                                        Logout
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item m-0">
                                                    <NavLink activeclassname="active" className="nav-link" to="/quote" onClick={handleNavClick}>
                                                        <ReceiptLongIcon />
                                                        <sub><b>{totalProducts}</b></sub>
                                                    </NavLink>
                                                </li>
                                            </> :
                                            <>
                                                <li className="nav-item">
                                                    <NavLink activeclassname="active" className="nav-link" to="/login" onClick={handleNavClick}>
                                                        Login / Register
                                                    </NavLink>
                                                </li>
                                            </>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
}
